<template>
    <vx-card title="Good Receive Reversal">
        <div class="flex vx-input-group">
            <vs-tabs :value="activeTab">
                <vs-tab label="Open">
                    <tab-open></tab-open>
                </vs-tab>
                <vs-tab label="Waiting">
                    <tab-waiting></tab-waiting>
                </vs-tab>
                <vs-tab label="Approved">
                    <tab-approved></tab-approved>
                </vs-tab>                
                <vs-tab label="Rejected">
                    <tab-rejected></tab-rejected>
                </vs-tab>
                <vs-tab label="Canceled">
                    <tab-canceled></tab-canceled>
                </vs-tab>
                <vs-tab label="Executed">
                    <tab-executed></tab-executed>
                </vs-tab>                
            </vs-tabs>
        </div>
    </vx-card>
</template>
<script>
import TabOpen from "./TabOpen.vue";
import TabWaiting from "./TabWaiting.vue";
import TabApproved from "./TabApproved.vue";
import TabRejected from "./TabRejected.vue";
import TabCanceled from "./TabCanceled.vue";
import TabExecuted from "./TabExecuted.vue";
export default {
    components: {
        TabOpen,
        TabWaiting,
        TabApproved,
        TabRejected,
        TabCanceled,
        TabExecuted,
    },
    data() {
        return {
            activeTab: sessionStorage.getItem('activeTabPO') ? sessionStorage.getItem('activeTabPO') : "0",
        }
    },
    methods: {},
    mounted(){
        console.log("index ===== ", sessionStorage.getItem('activeTabPO'))
    }
}
</script>
